// Column-name humanizer: snake_case fields → "Title Case Strings".
// Common acronyms are preserved uppercase ("BP ID", not "Bp Id").

const ACRONYMS = new Set([
  // Generic
  "ID",
  "URL",
  "API",
  "CSV",
  "PDF",
  "SQL",
  "IP",
  "UI",
  "OS",
  "KPI",
  "YOY",
  "MOM",
  "WOW",
  "QOQ",
  "TTM",
  "MRR",
  "ARR",
  "MTD",
  "YTD",
  "QTD",
  // Loan / FinBud
  "PL",
  "HL",
  "GL",
  "BL",
  "AL",
  "LAP",
  "LAS",
  "TW",
  "CC",
  "DPD",
  // SunMobility
  "BP",
  "SOC",
  "ESV",
  "BMS",
  "EV",
  "DC",
  "AC",
  // ITSM
  "SLA",
  "MTTR",
  "MTBF",
  // Common business terms that read better all-caps
  "CRM",
  "ERP",
  "ITSM",
]);

export function humanizeColumn(name: string): string {
  if (!name) return name;
  return name
    .split(/[_\s]+/)
    .filter((w) => w.length > 0)
    .map((w) => {
      const upper = w.toUpperCase();
      if (ACRONYMS.has(upper)) return upper;
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    })
    .join(" ");
}
